export default __webpack_public_path__ + "static/media/3d-cad.a32dde7a.png";